module.exports = __webpack_public_path__ + "img/tx.e165f738.png";